/**
 * Created by Pali on 23/07/18.
 */

angular.module("screensApp").controller("AnalysisController", function ($scope, $rootScope, AnalysisService, $element, $timeout, $sce, $q) {
  $scope.analysisData = null;
  $scope.listFontClasses = ["biggFont", "mediumFont", "smallFont"];
  $rootScope.fullyRendered = false;
  $scope.statsTableNames = [];

  // init loading indicator
  $scope.progressIds = ["empty", "quarter", "half", "threeQuartes", "full"];
  $scope.timeMs = 15000;
  $scope.timeMsPartial = $scope.timeMs / 4;

  // Show AnalysisContainer
  $rootScope.showAnalysis = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: $showAnalysis() data: ' + JSON.stringify(data));

    // hide analysis when eventID = 0
    if (data.eventID == null || data.eventID === 0) {
      $rootScope.hideAnalysis();
    }
    // load analysis
    $rootScope.settings.limitAge = true;
  };

  $rootScope.hideAnalysis = function () {
    // cancel all timeouts
    $timeout.cancel($scope.startLoaderTimeout);
    $timeout.cancel($scope.loaderPartialTimeout);
    $timeout.cancel($scope.statsCarouselTimeout);
    $timeout.cancel($scope.initViewTimeout);

    // analysis text on the right side isnt rendered (assigning font sizes)
    $rootScope.fullyRendered = false;

    $rootScope.settings.analysis.show = false;
  };

  $scope.analysisDataToModel = function (response, stats) {
    $rootScope.statsLabelName = $rootScope.translations.analysis[response.language].captionStatsFull;
    $scope.translationAnalysisDraw = $rootScope.translations.analysis[response.language].draw;
    $scope.translationAnalysisCaption = $rootScope.translations.analysis[response.language].caption;
    $scope.translationAnalysisCaptionFull = $rootScope.translations.analysis[response.language].captionFull;
    $scope.translationAnalysisMoreInfo = $rootScope.translations.analysis[response.language].moreInfo + " ";
    switch ($rootScope.config.Country) {
      case "LBR":
        $scope.translationAnalysisMoreInfo += "www.doxxbet.com.lr";
        break;
      case "SVK":
      default:
        $scope.translationAnalysisMoreInfo += "www.doxxbet.sk";
        break;
    }

    var allAnalysisModel = {
      sportID: response.sportID,
      eventID: response.eventID,
      banner: response.banner,
      eventDate: response.eventDate ? moment(response.eventDate).format("DD. MM. YYYY ") : "",
      eventTime: response.eventDate ? moment(response.eventDate).format("HH:mm") : "",
      leagueCupName: $scope.toUpperCase(response.leagueCupName),
      regionName: $scope.toUpperCase(response.regionName),
      sportName: $scope.toUpperCase(response.sportName),
      teamHome: response.teamHome,
      teamHomeLogo: $rootScope.settings.assetTeam + response.teamHomeID + ".png",
      teamAway: response.teamAway,
      teamAwayLogo: $rootScope.settings.assetTeam + response.teamAwayID + ".png",
      visibleDraw: stats.sportID != 58 ? "show-draw" : "no-draw",
      showOdds: response.showOdds,
      showStats: response.showStats,
      articleText: $("<textarea />").html($scope.removeAnchors(response.article)).text(),
      isAnalyzeAndH2h: false,
    };

    stats.tip1 ? stats.tip1 : 0;
    stats.tipX ? stats.tipX : 0;
    stats.tip2 ? stats.tip2 : 0;

    if (stats.tip1 === 0 && stats.tip2 === 0 && stats.tipX === 0) {
      allAnalysisModel.tip1 = 0;
      allAnalysisModel.tipX = 0;
      allAnalysisModel.tip2 = 0;
    } else {
      var sumStats = stats.tip1 + stats.tip2 + stats.tipX;
      allAnalysisModel.tip1 = Math.round((stats.tip1 * 100) / sumStats);
      allAnalysisModel.tipX = Math.round((stats.tipX * 100) / sumStats);
      allAnalysisModel.tip2 = Math.round((stats.tip2 * 100) / sumStats);
    }
    return allAnalysisModel;
  };

  // Load konkretnej analyzi
  $rootScope.loadAnalysisData = function (data) {
    $rootScope.hideAnalysis(); // cancel all timouts
    return $q(function (resolve) {
      AnalysisService.getEventAnalysisData(data.eventID).success(function (analysisDatas) {
        try {
          if (analysisDatas.response && analysisDatas.stats) {
            // analysis exists
            $rootScope.actualAnalysis = $scope.analysisDataToModel(analysisDatas.response, analysisDatas.stats);
            $scope.assignActualAnalysis(data);
            resolve(true);
          } else {
            // analysis does not exists
            resolve(false);
          }
        } catch (err) {
          // exception occured
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: loadAnalysisData() data: ' + JSON.stringify(data) + ' err: ' + err);
          $rootScope.hideAnalysis();
          resolve(false);
        }
      });
    });
  };

  $scope.assignActualAnalysis = function (data) {
    // analysis text on the right side isnt rendered (assigning font sizes)
    $rootScope.fullyRendered = false;
    if ($rootScope.actualAnalysis) {
      AnalysisService.getOddsData(data.eventID)
        .success(function (allEventIdData) {
          try {
            var eventOdds = allEventIdData.Odds;

            // Draw does not exists
            if (eventOdds && eventOdds[0] && eventOdds[1] && !eventOdds[2]) {
              $rootScope.actualAnalysis.odd1 = eventOdds[0].OddsRate;
              $rootScope.actualAnalysis.odd2 = eventOdds[1].OddsRate;
            }

            // Draw exists
            else if (eventOdds && eventOdds[0] && eventOdds[1] && eventOdds[2]) {
              $rootScope.actualAnalysis.odd1 = eventOdds[0].OddsRate;
              $rootScope.actualAnalysis.oddX = eventOdds[1].OddsRate;
              $rootScope.actualAnalysis.odd2 = eventOdds[2].OddsRate;
            }
            if (eventOdds && eventOdds[0] && eventOdds[1]) {
              $rootScope.actualAnalysis.showOdds = true;
            }
          } catch (err) {
            // Do not show odds if error
            $rootScope.actualAnalysis.showOdds = false;
            $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR AJAX: assignActualAnalysis() err: ' + err);
          }
        })
        .error(function (err) {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR AJAX: assignActualAnalysis() data: ' + JSON.stringify(data) + ' err: ' + err);
          $rootScope.hideAnalysis();
        });
      $rootScope.actualAnalysis.htmlTexts = $sce.trustAsHtml($rootScope.actualAnalysis.articleText);
    }
  };

  $rootScope.initView = function () {
    $scope.initViewTimeout = $timeout(function () {
      if ($rootScope.actualAnalysis.isAnalyzeAndH2h) {
        // Analysis and h2h
        $scope.progressQuartal = $(".circle-partial-bg")[0];
        $scope.progressQuartal.id = "empty";
        $scope.progressMask = $(".mask")[0];
        $scope.loader = $(".loader")[0];
        $scope.loaderStateIndex = 1;

        $scope.marginFromBottom = 360;
        $scope.initStatTables();
        $scope.statsTabCarouselIndex = 0;
        $scope.changeStatInCarousel();
        $scope.statsCarouselStart();
      } else {
        // Analysis alone - right container has full height
        $scope.marginFromBottom = 100;
      }
      // Common analysis and h2h
      $element.removeClass().addClass("common-header " + $rootScope.actualAnalysis.sportID);
      $scope.fitTextToScreen();

      $rootScope.settings.analysis.show = true;
    }, 0);
  };
  $scope.removeAnchors = function (textRaw) {
    return textRaw.replace(/((?=<a).*?(=?>)|(<\/a>))/g, "");
  };
  $scope.initStatTables = function () {
    if ($rootScope.myData && ($rootScope.myData.leagueFormTable || $rootScope.myData.lastMatchesCount)) {
      $scope.statsTableNames.push("league-table");
    }
    if ($rootScope.myData && ($rootScope.myData.lastMatches || $rootScope.myData.teams)) {
      $scope.statsTableNames.push("last-matches");
    }
    if ($rootScope.myData && $rootScope.myData.homeTeamForm && $rootScope.myData.homeTeamForm.lastTeamMatches.length >= 1) {
      $scope.statsTableNames.push("form-tableA");
    }
    if ($rootScope.myData && $rootScope.myData.awayTeamForm && $rootScope.myData.awayTeamForm.lastTeamMatches.length >= 1) {
      $scope.statsTableNames.push("form-tableB");
    }
  };

  // Left Side functions of view
  $scope.toUpperCase = function (dataString) {
    return dataString.toUpperCase();
  };

  $scope.statsCarouselStart = function () {
    if ($scope.statsTabCarouselIndex >= $scope.statsTableNames.length) $scope.statsTabCarouselIndex = 0;
    $scope.statsCarouselTimeout = $timeout(function () {
      $scope.changeStatInCarousel();
      $scope.statsCarouselStart();
    }, $scope.timeMs);
  };

  $scope.changeStatInCarousel = function () {
    $rootScope.actualAnalysis.statsCarouselName = "layouts/prematch/" + $scope.statsTableNames[$scope.statsTabCarouselIndex] + ".html";
    ++$scope.statsTabCarouselIndex;
    $scope.startLoader();
  };

  // Right Side of view functions
  $scope.fitTextToScreen = function () {
    if (!$scope.assigningFontClasses()) {

      var contentDiv = document.getElementById("content-text");
      var contentText = $rootScope.actualAnalysis.articleText;

      contentText = $scope.replaceAll(contentText, "<p>", "<p><span>");
      contentText = $scope.replaceAll(contentText, "</p><p>", "</span></p><p><span>");
      contentText = $scope.replaceAll(contentText, "</p>", "</span></p>");
      contentText = $scope.replaceAll(contentText, " ", " </span><span>");

      var elementsFromString = $scope.createElementFromHTML(contentText);
      contentDiv.innerText = "";
      elementsFromString.forEach(function (element) {
        contentDiv.appendChild(element);
      });

      var contentDivSpans = contentDiv.getElementsByTagName("span");
      var dottedSpan = false;
      for (var iContSpan = 0; iContSpan < contentDivSpans.length; iContSpan++) {
        if ($scope.isInViewport(contentDivSpans[iContSpan]) && !dottedSpan) {
          // document.getElementsByTagName(contentDivSpans[iContSpan]);
          contentDivSpans[iContSpan].style.visibility = "visible";
        } else {
          if (dottedSpan) {
            contentDivSpans[iContSpan].style.display = "none";
            // Next parent's sibling display change to none;
          } else {
            contentDivSpans[iContSpan].style.display = "none";
            dottedSpan = true;
            contentDivSpans[iContSpan - 1].innerText = "...";
          }
        }
      }
      var notice = document.getElementById("notice");
      notice.classList.remove("doNotDisplay");
    }
    // analysis text on the right side has been rendered (assigning text font sizes)
    $rootScope.fullyRendered = true;
  };

  // change loader indicator partials 4 - parts
  $scope.changeLoaderId = function () {
    $scope.loaderPartialTimeout = $timeout(function () {
      $scope.progressQuartal.id = $scope.progressIds[$scope.loaderStateIndex];
      if ($scope.loaderStateIndex === 2) {
        $scope.progressMask.style.zIndex = 0;
      }

      if ($scope.loaderStateIndex === 3) {
        // loader loading indicator has full size
        $scope.progressQuartal.id = "threeQuartes";
        // $scope.progressMask.style.zIndex = 10;
        $scope.loader.classList.remove("animated");
      }
      if ($scope.loaderStateIndex < 6) {
        $scope.changeLoaderId();
      }
      ++$scope.loaderStateIndex;
    }, $scope.timeMsPartial);
  };

  // init loader indicator, start loading
  $scope.startLoader = function () {
    $timeout.cancel($scope.loaderPartialTimeout);
    $timeout.cancel($scope.statsCarouselTimeout);
    $scope.progressQuartal.id = "empty";
    $scope.progressMask.style.zIndex = 10;
    $scope.loaderStateIndex = 1;
    $scope.loader.classList.add("animated");
    // $scope.loader.style.webkitTransform = "rotate(46deg)"; // continous loader to start position
    $scope.changeLoaderId();
  };

  // is element in viewport?
  $scope.isInViewport = function (element) {
    if ($rootScope.actualAnalysis.isAnalyzeAndH2h) {
      $scope.marginFromBottom = 360;
    } else {
      $scope.marginFromBottom = 80;
    }
    var rect = element.getBoundingClientRect();
    var html = document.documentElement;
    return rect.top >= 0 && rect.bottom <= (window.innerHeight - $scope.marginFromBottom || html.clientHeight - $scope.marginFromBottom);
  };

  $scope.assigningFontClasses = function () {
    for (var iClass = 0; iClass < $scope.listFontClasses.length; iClass++) {
      var contentElement = document.getElementById("content-text");
      if (contentElement) {
        contentElement.classList.add($scope.listFontClasses[iClass]);
        var elementInViewport = $scope.isInViewport(contentElement);
        var notice = document.getElementById("notice");
        notice.classList.add("doNotDisplay");
        if (elementInViewport) {
          contentElement.classList.remove("doNotDisplay");
          return true;
        } else {
          contentElement.classList.remove($scope.listFontClasses[iClass]);
        }
        if (!elementInViewport && iClass == $scope.listFontClasses.length - 1) {
          contentElement.classList.remove("doNotDisplay");
          return false;
        }
      } else {
        return true;
      }
    }
  };

  $scope.createElementFromHTML = function (htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();
    return div.childNodes;
  };

  $scope.replaceAll = function (target, search, replacement) {
    return target.replace(new RegExp(search, "g"), replacement);
  };

  $scope.$on("$destroy", function () {
    // cancel all timeouts
    $rootScope.hideAnalysis();
  });
});
